import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["wrapper", "image", "body"];

  connect() {
    window.addEventListener("load", () => this.compareHeights());

    window.addEventListener("resize", () => this.compareHeights());
    
    if (document.readyState === "complete") {
      this.compareHeights();
    }
  }

  compareHeights() {
    if (!this.hasImageTarget || !this.hasBodyTarget) return;
    
    const imageHeight = this.imageTarget.offsetHeight;
    const bodyHeight = this.bodyTarget.offsetHeight;
    const wrapper = this.wrapperTarget;
    const image = this.imageTarget;
    const body = this.bodyTarget;
    
    const isFloatRight = image.classList.contains("float-right");
    
    if (imageHeight > bodyHeight) {
        wrapper.classList.remove("overflow-hidden");
        
        image.classList.remove("float-left");
        image.classList.remove("float-right");
        image.classList.remove("w-full");
        image.classList.remove("ml-8");
        image.classList.remove("mr-8");
        image.classList.remove("mb-2");
        image.classList.remove("lg:mb-0");

        wrapper.classList.add("flex");
        wrapper.classList.add("flex-col");
        wrapper.classList.add("items-center");
        wrapper.classList.add("gap-6");
        wrapper.classList.add("w-full");
        
        if (isFloatRight) {
          wrapper.classList.add("md:flex-row-reverse");
        } else {
          wrapper.classList.add("md:flex-row");
        }

        image.style.width = '50%';
        body.style.width = '50%';
    } else if (bodyHeight > imageHeight) {
      this.element.classList.add("body-taller");
    } else {
      this.element.classList.add("heights-equal");
    }
  }
}
